import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Skeleton
} from '@mui/material';

const CollectionSkeletonCard = () => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Skeleton variant="text" width="60%" height={30} />
          <Skeleton variant="circular" width={40} height={40} />
        </Box>
        
        {/* Description Skeleton - two lines */}
        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="85%" height={20} sx={{ mb: 2 }} />
        
        {/* Footer Skeleton */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Skeleton variant="text" width="30%" height={20} />
          <Skeleton variant="text" width="30%" height={20} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default CollectionSkeletonCard; 